(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_FormBookNowV2__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7423);
/* harmony import */ var _components_HeroV2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2699);
/* harmony import */ var _components_SectionDining__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9646);
/* harmony import */ var _components_SectionEvent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3934);
/* harmony import */ var _components_SectionGallery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2493);
/* harmony import */ var _components_SectionHotel__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9938);
/* harmony import */ var _components_SectionSpecialOffer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3361);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4850);















var __N_SSG = true;
function Home(param) {
    var header = param.header, hotelBrands = param.hotelBrands, hero = param.hero;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), headerHeight1 = ref[0], setHeaderHeight = ref[1];
    var jsonLd = {
        "@context": "https://schema.org",
        "@type": "HotelGroup",
        "name": "Parador Hotels & Resorts",
        "url": "https://parador-hotels.com/",
        "logo": "https://parador-hotels.com/logo.png",
        "description": "Perusahaan manajemen hotel di Indonesia yang mengelola berbagai brand seperti Atria, Vega, dan Fame Hotels.",
        "address": {
            "@type": "PostalAddress",
            "addressLocality": "Tangerang",
            "addressRegion": "Banten",
            "addressCountry": "ID"
        },
        "subOrganization": [
            {
                "@type": "Hotel",
                "name": "Atria Hotel Gading Serpong",
                "description": "Hotel bisnis bintang 4 di jantung Gading Serpong."
            },
            {
                "@type": "Hotel",
                "name": "Fame Hotel Gading Serpong",
                "description": "Hotel bertema film yang unik dan modern di Gading Serpong."
            }, 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                title: !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(hotelBrands.meta_title_id) && locale == "id" ? hotelBrands.meta_title_id : !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(hotelBrands.meta_title_en) ? hotelBrands.meta_title_en : "Home | Parador Hotels & Resorts",
                description: !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(hotelBrands.meta_desc_id) && locale == "id" ? hotelBrands.meta_desc_id : !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(hotelBrands.meta_desc_en) ? hotelBrands.meta_desc_en : "WITH A CONSCIOUS HEART",
                image: !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(hotelBrands.meta_thumb) ? hotelBrands.meta_thumb : hero.slider[0].url,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jsonLd)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: true,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HeroV2__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                hasFormNow: true,
                heroItem: hero,
                height: "calc(100vh - ".concat(headerHeight1, "px)")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                position: "relative",
                bg: header.color_primary,
                top: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormBookNowV2__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    hotelCode: header.hotel_code,
                    colorPrimary: header.color_primary
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionSpecialOffer__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                isParador: true,
                hotelName: header.name,
                hotelLoc: header.hotel_location,
                hotel: header.name,
                hotelCode: header.hotel_code
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionDining__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionEvent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                color: header.color_primary,
                items: [
                    {
                        title: locale == "id" ? "Pernikahan" : "Wedding",
                        desctiption: locale == "id" ? "Rencanakan pernikahan di salah satu hotel Parador Hotels & Resorts. Wujudkan impian pernikahan dambaanmu." : "Plan a wedding at ".concat(header.is_parador ? "any Parador Hotel & Resort's property" : header.name, " and make your wedding dream come true."),
                        target: "/wedding",
                        thumbnail: header.wedding_thumbnail
                    },
                    {
                        title: locale == "id" ? "Acara sosial" : "Social Events",
                        desctiption: locale == "id" ? "Rencanakan acaramu. Biarkan kami melakukan sisanya" : "Plan your events ahead. Let us do the rest.",
                        target: "/meeting-events",
                        thumbnail: header.events_thumbnail
                    },
                    {
                        title: locale == "id" ? "Ruang Rapat" : "Meeting Room",
                        desctiption: locale == "id" ? "Terletak strategis, kami memiliki ruang pertemuan & layanan perjamuan yang cocok untuk memenuhi kebutuhan Anda." : "Strategically located, we offer comprehensive meeting rooms & banquet services that works best for you",
                        target: "/meeting-events",
                        thumbnail: header.meeting_thumbnail
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionHotel__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionGallery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                slug: null,
                color: "black",
                limit: 4,
                id: header.id
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,6394,9392,5299,4939,3981,3361,5316,9774,2888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);